// de_pms_checkin_stay.ts
// Tłumaczenia dla PMS.Checkin.tsx i PMS.Stay.tsx (oba ekrany Front Desk)

export const dePmsCheckinStay = {

  // ── Zameldowanie (Checkin) ────────────────────────────────────────────────
  checkin: {
    title:               "Rezeption",
    arrivalsToday:       "Anreisen heute",
    preCheckIn:          "Pre-Check-in",
    earlyCheckIn:        "Früher Check-in",
    depositRule:         "Anzahlungsregel",
    depositRuleRequired: "Die Anzahlungsregel ist erforderlich.",
    documentType:        "Dokumententyp",
    passport:            "Reisepass",
    idCard:              "Personalausweis",
    preauth:             "Vorautorisierung",
    searchPlaceholder:   "Name, Buchungsnummer, Zimmer, Telefon, E-Mail",
    readyRoom:           "Bezugsfertiges Zimmer",
    noReadyRoom:         "Kein bezugsfertiges Zimmer",
    noRoom:              "Kein Zimmer",
    missing:             "Fehlend",
    garage:              "Garage",
    messages: {
      completed:          "Check-in abgeschlossen. Schlüsselkodierung ist bereit.",
      completedSimple:    "Check-in abgeschlossen.",
      failed:             "Check-in fehlgeschlagen.",
      documentRegistered: "Gästedokument registriert und verifiziert.",
      documentFailed:     "Dokumentenregistrierung fehlgeschlagen.",
    },
  },

  // ── Zarządzanie pobytem (Stay) ────────────────────────────────────────────
  stay: {
    title:       "Aufenthaltsverwaltung",
    description: "Check-ins, Aufenthalte, Zimmerwechsel, Late Checkout und Checkout in einer Ansicht.",
    inHouseStays:"In-house-Aufenthalte",
    frontOffice: "Front Office",
    frontOfficeActions:"Front-Office-Aktionen",
    checkoutSettlement:"Checkout-Abrechnung",
    selectStay:  "Wählen Sie einen Aufenthalt aus und fahren Sie dann mit Late Checkout, Zimmerwechsel oder Checkout fort.",
    keepVisible: "Anreisen und Aktivität sichtbar halten, ohne Seiten zu wechseln.",
    lateCheckout: {
      title:         "Später Check-out",
      description:   "Aktive Aufenthalte verlängern und die Gebühr auf das Folio buchen.",
      applied:       "Später Check-out angewendet",
      workflowActive:"Late-Checkout-Workflow aktiv. Der aktive Aufenthalt ist bereits vorausgewählt.",
    },
    roomMove: {
      title:         "Zimmerwechsel",
      description:   "Gast in ein anderes bezugsfertiges Zimmer verlegen und einen neuen Schlüssel ausgeben.",
      completed:     "Zimmerwechsel abgeschlossen und neuer Schlüssel ausgegeben.",
      failed:        "Zimmerwechsel fehlgeschlagen.",
      selectRoom:    "Wählen Sie vor dem Zimmerwechsel ein bezugsfertiges Zimmer aus.",
    },
    checkout: {
      title:         "Check-out",
      settle:        "Folio abrechnen, Rechnung drucken oder per E-Mail senden und dann Checkout abschließen.",
      failed:        "Check-out fehlgeschlagen.",
      settled:       "Checkout abgerechnet und Rechnung erstellt.",
      workflowActive:"Checkout-Workflow aktiv. Folio prüfen und Aufenthalt schließen.",
    },
  },

} as const;

export default dePmsCheckinStay;
